var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoAttachment = function SvgVideoAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.606 6.985a1.999 1.999 0 0 1 0 3.53l-8.541 4.644C3.689 15.908 2 14.935 2 13.395v-9.29c0-1.54 1.69-2.512 3.065-1.765l8.541 4.645Z",
    stroke: "#fff"
  })));
};
export default SvgVideoAttachment;